module.exports = __webpack_public_path__ + "static/1304728656.7fff153c.jpg";